<template>
    <!--:list="state.list"    :loading="state.loading"-->
    <basic-list
        :fields="fields"
        :showIndexCol="false"
        :show-select-col="true"
        :show-action-col="false"
        :total="state.total"
        :list="state.list"
        :loading="state.loading"
        :table-h="tableH"
        :page-index="state.pageIndex"
        :page-size="state.pageSize"
        :page-index-change="pageIndexChange"
        :page-size-change="pageSizeChange"
        :selection-change="selectionChange"
        select-type="singleMult"
        highlight-current
    >
        <template slot="hd-col--l">
            <el-button type="primary" size="mini" @click="handleAdd" v-if="buttonData('tjsjlx').has">{{buttonData('tjsjlx').name}}</el-button>
            <el-button  size="mini" @click="onView" v-if="buttonData('sjlxxq').has">{{buttonData('sjlxxq').name}}</el-button>
            <el-button  size="mini" @click="onEdit" v-if="buttonData('bjsjlx').has">{{buttonData('bjsjlx').name}}</el-button>
            <el-button type="danger" size="mini" @click="onDetele" >{{$t('language.5o6u3frcmco0')}}</el-button>
        </template>
    </basic-list>
</template>

<script>
import ExactList from '@/mixins/exactList'

export default {
    mixins: [ExactList],
    props:{
        handleView:Function,
    },
    data () {
        return {
            fields: [
                { key: 'typeCode', name: this.$t('language.5o6vk82zm180')},
                { key: 'typeName', name: this.$t('language.5o6vk82zm540')},
                { key: 'createTime', name: this.$t('language.5o6otz4p1t00')},
                { key: 'remark', name: this.$t('language.5o6otz4p1w00') },
            ],
        }
    },
    methods:{
        onEdit () {
            const rows = this.selRows
            if (!rows.length) {
                this.$message.error(this.$t('language.5o6v4bolgjc0'))
                return
            }
            if (rows.length > 1) {
                this.$message.error(this.$t('language.5o6v4bolglk0'))
                return
            }
            this.handleEdit({id:rows[0].id},true)

        },
        onDetele(){
            const rows = this.selRows
            if (!rows.length) {
                this.$message.error(this.$t('language.5o6v4bolg8s0'))
                return
            }
            if (rows.length > 1) {
                this.$message.error(this.$t('language.5o6v4bolgcc0'))
                return
            }
            this.handleDelete(rows[0])
        },

        onView(){
            const rows = this.selRows
            if (!rows.length) {
                this.$message.error(this.$t('language.5o6vk82zmpg0'))
                return
            }
            if (rows.length > 1) {
                this.$message.error(this.$t('language.5o6vk82zmrw0'))
                return
            }
            this.handleView({id:rows[0].id},true)
        }
    }
}
</script>

